export const extractConfigDefinitionTypesMap = (configDefinition) =>
  Object.fromEntries(
    Object.entries(configDefinition?.properties || {}).map(([key, value]) => [key, value.type])
  );

export const extractConfigDefinitionSubTypesMap = (configDefinition) =>
  Object.fromEntries(
    Object.entries(configDefinition?.properties || {})
      .filter(([, value]) => value?.subType !== undefined)
      .map(([key, value]) => [key, value.subType])
  );

export const parseConfig = async (config, configDefTypesMap) => {
  const parsedConfig = _.reduce(config, (acc, val, key) => {
    if (val !== undefined) {
      acc[key] = configDefTypesMap[key]?.type === 'object' && typeof val !== 'object'
        ? JSON.parse(val)
        : val;
    }
    return acc;
  }, {});

  if (parsedConfig.file instanceof Weaver.File) {
    const uploadedFile = await parsedConfig.file.upload();
    return { ...parsedConfig, file: uploadedFile.id() };
  }

  return parsedConfig;
};

export const cleanUpNewTask = ({ config = {}, name, functionalityName, functionalityVersion, branch }) => ({
  userId: Weaver.getInstance().currentUser().id(),
  branch,
  functionalityName,
  functionalityVersion,
  name,
  config
});

export const cleanUpEditedTask = ({ scheduleUid, config = {} }) => ({
  user: Weaver.getInstance().currentUser().id(),
  scheduleUid,
  config
});

export const splitConfigByParams = (fullConfig, functionalityProperties = {}) => {
  const isParamKey = (key, cfg) =>
    key === 'file' || cfg?.subType === 'json5-with-vars';

  const paramKeys = Object.entries(functionalityProperties)
    .filter(([key, cfg]) => isParamKey(key, cfg))
    .map(([key]) => key);

  const config = { ...fullConfig };
  const parameters = {};

  for (const key of paramKeys) {
    if (key in config) {
      parameters[key] = config[key];
      delete config[key];
    }
    if (`${key}-vars` in config) {
      parameters[`${key}-vars`] = config[`${key}-vars`];
      delete config[`${key}-vars`];
    }
  }

  return { config, parameters };
};
